import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PosCatalogProductDto } from '@klubovna/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryColor, PaymentType } from '@posTypes';

@Component({
  selector: 'app-pos-product-card',
  standalone: true,
  imports: [ DecimalPipe, NgClass, TranslateModule ],
  templateUrl: './pos-product-card.component.html',
  styleUrl: './pos-product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosProductCardComponent {
  product = input.required<PosCatalogProductDto>();
  quantity = input(0);
  showFavoriteButton = input(true);
  categoryColor = input<CategoryColor | null>(null);

  addToCart = output<PaymentType>();
  toggleFavorite = output<void>();

  readonly PaymentType = PaymentType;

  priceFormatted = computed(() => {
    return this.product().priceCents / 100;
  });

  pointsCost = computed(() => {
    return this.product().pointsCost;
  });

  canPayWithPoints = computed(() => {
    return this.product().pointsCost > 0;
  });

  isActive = computed(() => {
    return this.product().isActive;
  });

  isComposite = computed(() => this.product().isComposite ?? false);

  isLowStock = computed(() => !this.isComposite() && this.product().stockQty <= 0);

  isFavorite = computed(() => {
    return this.product().isFavourite;
  });

  onCardClick(): void {
    if (this.isActive()) {
      this.addToCart.emit(PaymentType.Money);
    }
  }

  onAddWithPoints(event: Event): void {
    event.stopPropagation();
    if (this.isActive() && this.canPayWithPoints()) {
      this.addToCart.emit(PaymentType.Points);
    }
  }

  onToggleFavorite(event: Event): void {
    event.stopPropagation();
    this.toggleFavorite.emit();
  }
}
